export default __webpack_public_path__ + "static/media/1343.1d8f08d3.png";